/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-28 18:06:30
 * @LastEditors: lxh3@meitu.com
 * @LastEditTime: 2025-06-25 17:09:23
 * @FilePath: /roboneo-web/src/common/pageType.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEstudio
 */
export type PageId =
  | 'home'
  | 'homeOld'
  | 'ai_flow'
  | 'studio'
  | 'project'
  | 'teamProject'
  | 'assets'
  | 'community'
  | 'communityDetail'
  | 'social_case'
  | 'myips'
  | 'myIpCreation'
  | 'myIpDetail'
  | 'viralRemake'
  | 'case_detail'
  | 'case_preview'
  | 'data_dashboard';
  // | 'share'
  // | 'ppt'
  // | 'share_cover'
  // | 'hot_feed';
export interface PageInfo {
  projectId: string;
  regExp: RegExp;
  moduleId: string;
  chineseName: string;
  location: number;
  // locationName: 'home' | 'studio' | 'share' | 'ppt' | 'share_cover' | 'hot_feed';
  locationName: 'home' | 'studio' | 'ai_flow' | 'project' | 'team_project'
  | 'assets'
  | 'community' | 'communityDetail' | 'social_case'
  | 'myips' | 'myIpCreation' | 'myIpDetail' | 'viralRemake' | 'case_detail' | 'case_preview' | 'data_dashboard';
}

export const pageMap: Record<PageId, PageInfo> = {
  assets: {
    projectId: '/--roboneo',
    regExp: /^\/(?:--roboneo\/)?assets\/?$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'assets',
  },
  case_preview: {
    projectId: '/--roboneo',
    regExp: /^\/(?:--roboneo\/)?case_preview\/?$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'case_preview',
  },
  viralRemake: {
    projectId: '/--roboneo',
    regExp: /^\/(?:--roboneo\/)?viral-remake\/?$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'viralRemake',
  },
  myips: {
    projectId: '/--roboneo',
    regExp: /\/myips\/?$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'myips',
  },
  myIpCreation: {
    projectId: '/--roboneo',
    regExp: /^\/(?:--roboneo\/)?myips\/create\/?$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'myIpCreation',
  },
  myIpDetail: {
    projectId: '/--roboneo',
    regExp: /\/myips\/(?!create\/?$)[^/]+\/?$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'myIpDetail',
  },
  home: {
    projectId: '/--roboneo',
    regExp: /\/home\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'home',
  },
  homeOld: {
    projectId: '/--roboneo',
    regExp: /\/home_old\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'home',
  },
  studio: {
    projectId: '/--roboneo',
    regExp: /\/studio\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'studio',
  },
  ai_flow: {
    projectId: '/--roboneo',
    regExp: /\/ai_flow\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'ai_flow',
  },
  project: {
    projectId: '/--roboneo',
    regExp: /\/project\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'project',
  },
  teamProject: {
    projectId: '/--roboneo',
    regExp: /\/team_project\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'team_project',
  },
  community: {
    projectId: '/--roboneo',
    regExp: /\/community\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'community',
  },
  communityDetail: {
    projectId: '/--roboneo',
    regExp: /\/community\/.+$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'communityDetail',
  },
  social_case: {
    projectId: '/--roboneo',
    regExp: /\/social_case\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'social_case',
  },
  case_detail: {
    projectId: '/--roboneo',
    regExp: /\/case_detail\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'case_detail',
  },
  data_dashboard: {
    projectId: '/--roboneo',
    regExp: /\/data_dashboard\/$/,
    moduleId: '',
    chineseName: '',
    location: 0,
    locationName: 'data_dashboard',
  },
  // share: {
  //   projectId: '/--roboneo',
  //   regExp: /\/share\/$/,
  //   moduleId: '',
  //   chineseName: '',
  //   location: 0,
  //   locationName: 'share',
  // },
  // ppt: {
  //   projectId: '/--roboneo',
  //   regExp: /\/ppt\/$/,
  //   moduleId: '',
  //   chineseName: '',
  //   location: 0,
  //   locationName: 'ppt',
  // },
  // share_cover: {
  //   projectId: '/--roboneo',
  //   regExp: /\/share_cover\/$/,
  //   moduleId: '',
  //   chineseName: '',
  //   location: 0,
  //   locationName: 'share_cover',

  // },
  // hot_feed: {
  //   projectId: '/--roboneo',
  //   regExp: /\/hot_feed\/$/,
  //   moduleId: '',
  //   chineseName: '',
  //   location: 0,
  //   locationName: 'hot_feed',
  // },
};
